<template>
    <v-edit-dialog @save="updateSession" persistent large>
        {{ currentSession.name }}
        <v-btn icon small class="ml-1">
            <v-icon small color="primary">mdi-pencil</v-icon>
        </v-btn>
        <template v-slot:input>
            <v-select
                :value="currentSession.id"
                :items="sessions"
                @change="changeSession"
                item-text="name"
                item-value="id"
                return-object
            ></v-select>
        </template>
    </v-edit-dialog>
</template>

<script>
export default {
    name: "program-session-select",
    props: {
        sessions: {
            type: Array,
            required: true,
        },
    },
    computed: {
        currentSession() {
            return this.sessions.length > 0
                ? this.sessions.find((session) => session.isCurrent)
                : {};
        },
    },
    methods: {
        updateSession() {
            console.log("Update session on save");
        },
        changeSession() {
            console.log("Change to selected session");
        },
    },
};
</script>

<style lang="scss" scoped>
</style>